import React, { useState, useEffect } from 'react';
import { Activity } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuditView = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.get(`${API}/audit`, {
          params: { limit: 100 },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        setLogs(res.data.logs || []);
        setTotal(res.data.total || 0);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    };
    fetchLogs();
  }, []);

  return (
    <div>
      <div style={{ marginBottom: '2rem' }}>
        <h1 className="dash-content__title">AUDIT LOG</h1>
        <p className="dash-content__subtitle">{total} events logged</p>
      </div>

      <div style={{ background: 'var(--surface)', border: '1px solid var(--border-dim)', padding: '1.5rem' }}>
        {loading ? (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>Loading...</div>
        ) : logs.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--text-muted)', padding: '2rem' }}>No events</div>
        ) : (
          <table className="dash-table">
            <thead>
              <tr>
                <th>TIME</th>
                <th>USER</th>
                <th>ACTION</th>
                <th>DETAILS</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, i) => (
                <tr key={log.id || i} data-testid={`audit-entry-${i}`}>
                  <td style={{ fontFamily: 'var(--font-mono)', fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
                    {new Date(log.timestamp).toLocaleString()}
                  </td>
                  <td style={{ color: 'var(--astros-orange)', fontWeight: 600 }}>{log.actor_email}</td>
                  <td>
                    <span style={{ background: 'rgba(235, 110, 31, 0.08)', border: '1px solid rgba(235, 110, 31, 0.2)', padding: '0.2rem 0.5rem', fontSize: '0.72rem', color: 'var(--astros-orange)', fontWeight: 700 }}>
                      {log.action}
                    </span>
                  </td>
                  <td style={{ fontSize: '0.82rem' }}>
                    {log.target && `Target: ${log.target}`}
                    {log.ip && ` | IP: ${log.ip}`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AuditView;
